import React, { useState, useRef } from "react";
import "./FaultSecondPageCustom_Coral.css";
import * as $ from "jquery";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";

import { INIT_STATE_SELECTS } from "../../../../constants/driveglobalfilterinitialstates_coral";

export default function FaultSecondPageFilters_Coral(props) {
  const [filterdata, setFilterData] = useState({ ...props.secondPageState });
  const [singlevinerr, setSingleVinErro] = useState(false);
  const inputElement = useRef();

  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  };

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    setSingleVinErro(false);
    if (enterter_vin != "") {
      if (enterter_vin.indexOf(",") == -1) {
        setFilterData((prestate) => {
          return { ...filterdata, vin_num: enterter_vin };
        });
      } else {
        setSingleVinErro(true);
      }
    } else {
      setSingleVinErro(true);
    }
  };
  const startDateChanged = (date) => {
    setFilterData((prestate) => {
      return { ...filterdata, startDate: date };
    });
  };
  const endDateChanged = (date) => {
    setFilterData((prestate) => {
      return { ...filterdata, endDate: date };
    });
  };

  const onsubmit = (e) => {
    e.preventDefault();
    if (inputElement.current.value == "") {
      setSingleVinErro(true);
    } else {
      props.onsubmit(filterdata);
    }
  };

  const onreset = (e) => {
    e.preventDefault();
    setFilterData(INIT_STATE_SELECTS);
    inputElement.current.value = "";
    props.onreset(INIT_STATE_SELECTS);
  };

  return (
    <div className="container-fluid mainDiv">
      <div className="text-end ev-auto">
        <button
          type="button"
          id="filterIcon"
          className="btn btn-outline-primary material-icons ev_filter_icon"
          onClick={filterHideShow}
        >
          filter_alt
        </button>
      </div>
      <div
        className="bg-light  FilterDiv p-3  mb-3"
        id="filterSearch"
        style={{ display: "none", zIndex: 1 }}
      >
        {/* Filters area here */}
        {/* Filter Form Starts */}
        <form className="row g-3 mt-2 filterForm">
          <div className="row">
            <div className="col-lg-7">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="select_col_title form-label"
                    >
                      Start Date
                    </label>
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      minDate={moment(
                        new Date("2022-07-01T00:00:00.000Z")
                      ).toDate()}
                      maxDate={moment().subtract(1, "days").toDate()}
                      selected={filterdata.startDate}
                      onChange={startDateChanged}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput2"
                      className="select_col_title form-label"
                    >
                      End Date
                    </label>
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      minDate={moment(
                        new Date("2022-07-01T00:00:00.000Z")
                      ).toDate()}
                      maxDate={moment().subtract(1, "days").toDate()}
                      selected={filterdata.endDate}
                      onChange={endDateChanged}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput2"
                      className="select_col_title form-label"
                    >
                      Vin No / Chassis No
                    </label>
                    <input
                      autoComplete="off"
                      defaultValue={filterdata.vin_num}
                      className="top-filter filter-col"
                      placeholder="Vin No / Chassis No"
                      id="vin_num"
                      ref={inputElement}
                      onBlur={vinnumChanged}
                    />
                    {singlevinerr && (
                      <spna
                        style={{
                          fontSize: "11px",
                          color: "red",
                          fontWeight: 800,
                        }}
                      >
                        * Please enter single Vin Number
                      </spna>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="mt-3">
                    <label className="form-label" />
                    <button
                      className="form-control btn btn-primary"
                      onClick={onsubmit}
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="mt-3">
                    <label className="form-label" />
                    <button
                      className="form-control btn btn-secondary"
                      onClick={onreset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="mt-3">
                    <label className="form-label" />
                    <button
                      type="submit"
                      className="form-control btn btn-primary"
                    >
                      <BsFillSkipBackwardBtnFill />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/* Filter Form Ends */}
      </div>
    </div>
  );
}
